import { SubscriptionModel, SubscriptionStatus } from '../models';

const subscriptionStatusPriority: { [K in SubscriptionStatus]: number } = {
  active: 3,
  plan_change_scheduled: 3,
  on_hold: 2,
  canceled: 1,
  trial: 0,
  expired: 0,
  cancellation_scheduled: 0,
  past_due: 0,
  paused: 0,
  unpaid: 0,
  trial_expired: 0,
};

const sortByStatus = (a: SubscriptionStatus, b: SubscriptionStatus) => {
  if (subscriptionStatusPriority[a] === subscriptionStatusPriority[b]) {
    return 0;
  }
  return subscriptionStatusPriority[a] < subscriptionStatusPriority[b] ? 1 : -1;
};

const sortByDate = (a: string | null, b: string | null) => {
  if (a === null) return 1;
  if (b === null) return -1;
  return new Date(a).getTime() - new Date(b).getTime();
};

const sortAlphabetically = (a: string, b: string) => {
  return a.localeCompare(b);
};

export const sortSubscriptions = (
  subA: SubscriptionModel,
  subB: SubscriptionModel
) => {
  const sortByStatusValue = sortByStatus(subA.status, subB.status);
  if (sortByStatusValue) {
    return sortByStatusValue;
  }

  if (subA.currentPeriodEndsAt || subB.currentPeriodEndsAt) {
    return sortByDate(subA.currentPeriodEndsAt, subB.currentPeriodEndsAt);
  }

  return sortAlphabetically(subA.product.name, subB.product.name);
};
